// extracted by mini-css-extract-plugin
export var inline = "_wd-0";